import { apiFetch } from '@ami/react/core';

export class ProductOptionBrand {
  constructor(json) {
    this.id = json.id;
    this.name = json.name;
    this.label = json.name;
    this.series = json.series.map(
      (x) =>
        new ProductOptionSeries({
          id: x.id,
          name: x.name,
          internalName: x.internalName,
          label: x.label,
        })
    );
  }
}

export class ProductOptionSeries {
  constructor(json) {
    this.id = json.id;
    this.name = json.name;
    this.internalName = json.internalName;
    this.label = json.name;
  }
}

export class Manufacturer {
  constructor(make) {
    this.id = make;
    this.label = make;
  }
}

export class Carrier {
  constructor(json) {
    this.id = json.id;
    this.name = json.name;
    this.label = json.name;
    this.imageUrl = json.imageUrl;
    this.weightCategories = json.weightCategories.map(
      (x) => new WeightCategory(x)
    );
    this.attachmentPoints = this._parseAttachmentPoints(json.attachmentPoints);
    this.isDisabled = json.isDisabled;
  }

  _parseWeightCategoryResult(weightCategories) {
    return weightCategories.map((x) => new WeightCategory(x));
  }

  _parseAttachmentPoints(attachmentPoints) {
    return attachmentPoints.map(
      (point) =>
        new AttachmentPoint({
          id: point.id,
          name: point.name,
          label: point.name,
          imageUrl: point.imageUrl,
          productCategories: point.productCategories.map(
            (x) => new ProductCategory(x)
          ),
          compatibleCouplerDecisions: point.compatibleCouplerDecisions,
          type: point.type
        })
    );
  }
}

export class WeightCategory {
  constructor(json) {
    this.id = json.id;
    this.label = json.label;
    this.name = json.name;
    this.description = json.description;
    this.isDisabled = json.isDisabled;
  }
}

export class FlatWeightCategory extends WeightCategory {
  constructor(weightCategory, carrier) {
    super(weightCategory);
    this.carrierId = carrier.id;
    this.carrierLabel = carrier.label;
  }
}

export class ProductCategory {
  constructor(json) {
    this.id = json.id;
    this.name = json.name;
    this.label = json.name;
    this.imageUrl = json.imageUrl;
  }
}

export class AttachmentPoint {
  constructor(json) {
    this.id = json.id;
    this.name = json.name;
    this.label = json.name;
    this.imageUrl = json.imageUrl;
    this.productCategories = json.productCategories;
    this.compatibleCouplerDecisions = json.compatibleCouplerDecisions;
    this.type = json.type;
  }
}

export class ProductConfiguration {
  constructor(json) {
    if (json) {
      this.manufacturers = json.manufacturers.map((m) => new Manufacturer(m));
      this.carriers = json.carriers.map((x) => new Carrier(x));
      this.productOption = this._parseProductOption(json.productOption);
      this.productMarketing = json.productMarketing;
      return;
    }

    this.manufacturers = [];
    this.carriers = [];
    this.productOption = { series: [] };
    this.productMarketing = null;
  }

  getFlatWeightCategories() {
    const result = [];
    this.carriers.forEach((carrier) =>
      carrier.weightCategories.forEach((weightCategory) => {
        result.push(new FlatWeightCategory(weightCategory, carrier));
      })
    );
    return result;
  }

  getProductCategoriesFor(carrierId, attachmentPointId) {
    return this.carriers
      .find((x) => x.id === carrierId)
      .attachmentPoints.find((x) => x.id === attachmentPointId)
      .productCategories;
  }
  
  _parseProductOption(productOptionResult) {
    return {
      brands: productOptionResult.brands.map(
        (x) =>
          new ProductOptionBrand({
            id: x.id,
            name: x.name,
            label: x.label,
            series: x.series,
          })
      ),
    };
  }

  static async get(isPublic) {
    const json = await apiFetch(
      'configurations/products',
      'GET',
      null,
      null,
      isPublic
    );
    return new ProductConfiguration(json);
  }
}
